export const integrationEndpoints = {
  sdmProjects: "/integrations/sdm/projects",
  sdmImport: (reportId) => `/integrations/sdm/import/${reportId}`,
};
